import React from 'react';
import Dashboard from '../Dashboard';
import MoreTravellersMain from './MoreTravellersMain'
export default function MoreTravellers() {
    return (
        <div>
            <Dashboard cmp={<MoreTravellersMain />} />
        </div>
    )
}

